export default __webpack_public_path__ + "static/media/screenBlock15.3e1e039c.jpg";